import { PropTypes } from 'react'
import classNames from 'classnames'
import SVGButton from '../SVGButton'
import styles from './style.styl'
import CLOSE_SVG from '!svg-inline-loader?removeTags=true!./images/close-button.svg'
import { DEFAULT_HEADER_COLOR } from './constants'

export default function CloseButton(props) {
  const { className, color, onClose, children, ...rest } = props
  return (
    <SVGButton
      {...rest}
      onClick={onClose}
      className={classNames(styles.Header__close_btn, className)}
      svgString={CLOSE_SVG}
      hoverBackgroundColor={color}/>
  )
}
CloseButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  color: PropTypes.string,
}
CloseButton.defaultProps = {
  color: DEFAULT_HEADER_COLOR,
}



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/Header/CloseButton.js